import * as React from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import cx from 'classnames';
import { Dialog, DialogContent } from '../Dialog';

type Props = {
  isShow: boolean;
  onHide: () => unknown;
  title: string;
  continueButtonLabel?: string;
  cancelButtonLabel?: string;
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  onYesResponse: () => unknown;
  onNoResponse: () => unknown;
  enableCloseButton?: boolean;
};

class YesNoDialog extends React.Component<Props> {
  render(): JSX.Element {
    const { isShow, onHide, className, enableCloseButton, title, children, onNoResponse, onYesResponse } = this.props;

    return (
      <Dialog
        open={isShow}
        onOpenChange={(isOpen) => {
          if (!isOpen && enableCloseButton) {
            onHide();
          }
        }}
      >
        <DialogContent
          className={cx(
            'w-[min(95vw,500px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]',
            className,
          )}
          overlayClassName='bg-black/50'
          onEscapeKeyDown={(event) => {
            if (!enableCloseButton) {
              event.preventDefault();
            }
          }}
          onPointerDownOutside={(event) => {
            if (!enableCloseButton) {
              event.preventDefault();
            }
          }}
        >
          <div className='relative px-[2.6rem] pb-[1.6rem] pt-[2.8rem]'>
            {enableCloseButton && (
              <button
                type='button'
                onClick={onHide}
                aria-label='Close'
                className='absolute right-[1rem] top-[0.7rem] border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424]'
              >
                x
              </button>
            )}
            <h3 className='m-0 text-center text-[#242424]'>{title}</h3>
          </div>

          <div className='mx-[2.6rem] mb-[2.6rem] mt-[0.4rem] flex flex-col gap-[3rem]'>
            {typeof children === 'string' ? <p className='m-0'>{children}</p> : children}
            <div className='flex items-center justify-center gap-[2rem] [&>div]:flex-1 [&>div>button]:w-full'>
              <PrimaryButton onClick={onNoResponse} alertSecondary small>
                {this.props.cancelButtonLabel || 'No'}
              </PrimaryButton>
              <PrimaryButton onClick={onYesResponse} small>
                {this.props.continueButtonLabel || 'Yes'}
              </PrimaryButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default YesNoDialog;
